"use client"

import * as React from "react"
import { ScrollArea as ScrollAreaPrimitive } from "radix-ui"

import { cn } from "../lib/utils"

function ScrollArea({
  className,
  children,
  ...props
}: React.ComponentProps<typeof ScrollAreaPrimitive.Root>) {
  return (
    <ScrollAreaPrimitive.Root
      data-slot="scroll-area"
      // `overflow-hidden` allein reicht nicht: unter einem `max-h-*`-Root
      // (anders als bei festem `h-*` oder Flex-Stretch, siehe ChatPage.tsx)
      // hat `height` selbst weiter den Wert `auto` — eine Prozent-Höhe wie
      // `size-full` am Viewport löst dagegen nur auf, wenn der Elternwert
      // DEFINIT ist, `max-height` zählt dafür nicht (CSS-Spec). Der Viewport
      // wuchs dadurch auf seine Inhaltshöhe und lief über den sichtbaren
      // Rahmen hinaus, statt intern zu scrollen (Vorfall 2026-09-07,
      // Glocken-Menü NotificationBell: Text vom eigenen Scrollbalken
      // überdeckt, „Alle ansehen" scheinbar über der Liste schwebend). Fix:
      // Root als Flex-Spalte, Viewport als `flex-1 min-h-0` — Flexbox
      // berechnet die verfügbare Höhe korrekt aus dem (ggf. `max-height`-
      // gedeckelten) Container, unabhängig von der Prozent-Höhen-Regel.
      className={cn("relative flex flex-col overflow-hidden", className)}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport
        data-slot="scroll-area-viewport"
        className="min-h-0 w-full flex-1 rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1"
      >
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  )
}

function ScrollBar({
  className,
  orientation = "vertical",
  ...props
}: React.ComponentProps<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>) {
  return (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      data-slot="scroll-area-scrollbar"
      data-orientation={orientation}
      orientation={orientation}
      className={cn(
        "flex touch-none p-px transition-colors select-none data-horizontal:h-2.5 data-horizontal:flex-col data-horizontal:border-t data-horizontal:border-t-transparent data-vertical:h-full data-vertical:w-2.5 data-vertical:border-l data-vertical:border-l-transparent",
        className
      )}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb
        data-slot="scroll-area-thumb"
        className="relative flex-1 rounded-full bg-border"
      />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  )
}

export { ScrollArea, ScrollBar }
